export const MODAL_MESSAGES = {
  EVENT: "Evento",
  NAME: "Fecha y hora",
  PATIENT: "Paciente",
  CAMPUS: "Sede",
  STATUS: "Estado",
  SEE_HU: "Ver historia clínica",
  SEE_SERVICE: "Ver servicio",
  DOCUMENT: "Documento"
};
